import { z } from 'zod';

import {
  cashOperationValues,
  cashPrerequisiteKindValues,
  cashPrerequisiteReasonValues,
  type CashOperation,
  type CashPrerequisiteBlockerDto,
  type CashPrerequisiteKind,
  type CashPrerequisiteReason,
  type CheckCashPrerequisitesRequest,
  type CheckCashPrerequisitesResponse,
} from './cash-prerequisites.dto.js';
import type { CashConfigProvenance } from './cash-locations.dto.js';
import { cashConfigProvenanceValues } from './cash-locations.dto.js';

export const CashOperationSchema: z.ZodType<CashOperation> = z.enum(cashOperationValues);
export const CashPrerequisiteKindSchema: z.ZodType<CashPrerequisiteKind> = z.enum(
  cashPrerequisiteKindValues,
);
export const CashPrerequisiteReasonSchema: z.ZodType<CashPrerequisiteReason> = z.enum(
  cashPrerequisiteReasonValues,
);
export const CashPrerequisiteRequiredProvenanceSchema: z.ZodType<CashConfigProvenance> = z.enum(
  cashConfigProvenanceValues,
);

export const CashPrerequisiteBlockerDtoSchema: z.ZodType<CashPrerequisiteBlockerDto> = z.object({
  kind: CashPrerequisiteKindSchema,
  reason: CashPrerequisiteReasonSchema,
  entityId: z.uuid().nullable(),
  message: z.string().trim().min(1),
  canRemediate: z.boolean(),
  requiredProvenance: CashPrerequisiteRequiredProvenanceSchema.optional(),
});

export const CheckCashPrerequisitesRequestSchema: z.ZodType<CheckCashPrerequisitesRequest> =
  z.object({
    companyId: z.uuid(),
    operation: CashOperationSchema,
    storeId: z.uuid().optional(),
    locationId: z.uuid().optional(),
    stationId: z.uuid().optional(),
    cashLocationId: z.uuid().optional(),
    relatedCashLocationId: z.uuid().optional(),
    cashSessionId: z.uuid().optional(),
    caseId: z.uuid().optional(),
    relatedCaseId: z.uuid().optional(),
    actionId: z.uuid().optional(),
    expenseId: z.uuid().optional(),
    transferId: z.uuid().optional(),
    categoryId: z.uuid().nullable().optional(),
  });

export const CheckCashPrerequisitesResponseSchema: z.ZodType<CheckCashPrerequisitesResponse> =
  z.object({
    operation: CashOperationSchema,
    ready: z.boolean(),
    blockers: z.array(CashPrerequisiteBlockerDtoSchema),
    warnings: z.array(z.string().trim().min(1)),
  });
